var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wb-elements-item-card-uploading"},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.text))]),_c('el-progress',{attrs:{"percentage":_vm.percentage,"format":_vm.formatPercentage,"stroke-width":6,"color":'#4780FF'}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }